import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getCookie } from '../@core/utils/get-cookie.utils';
import { HrDocumentationService } from '../services/hr-documentation.service';
import { UsersService } from '../services/users.service';


@Injectable({
  providedIn: 'root',
})
export class HrDocumentationGuard implements CanActivate {
  loggedInStatus: boolean = false;

  constructor(private router: Router, private hrDocumentationService: HrDocumentationService, private userService: UsersService) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    const token = getCookie('myesse_access_token');

    if (this.loggedInStatus) {
      return true;
    }

    const usedIdp = getCookie('active_idp');
    if (usedIdp === 'ias-white-oidc' || usedIdp === 'ias-blue-oidc') {
      localStorage.setItem('oidc-login', usedIdp);
    } else {
      return false;
    }

    const result = await this.userService.validateToken(token!);
    this.loggedInStatus = result;

    if (this.loggedInStatus) {
    } else {
      this.router.navigate(['/auth/login']);
    }

    return this.loggedInStatus;
  }
}
